/**
 * Sanitize Referral Code Utility
 *
 * Cleans and validates referral codes from URL parameters to prevent XSS
 * and ensure format compliance.
 */

/**
 * Sanitizes a referral code by:
 * - Allowing only alphanumeric characters (A-Z, 0-9)
 * - Converting to uppercase
 * - Limiting length to 8 characters
 * - Returning null if input is invalid
 *
 * @param code - Raw referral code from URL parameter
 * @returns Sanitized code or null if invalid
 */
export const sanitizeRefCode = (code: string | null): string | null => {
  if (!code) return null;

  // Remove all non-alphanumeric characters
  const sanitized = code.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

  // Return null if empty after sanitization
  if (sanitized.length === 0) return null;

  // Limit to 8 characters max
  return sanitized.substring(0, 8);
};

export default sanitizeRefCode;
